// extracted by mini-css-extract-plugin
module.exports = {"loginFormWrapper":"LoginForm__loginFormWrapper___mdbai","loginInput":"LoginForm__loginInput___3m5pQ","forgotButton":"LoginForm__forgotButton___tLxlN"};